<template>
  <Navbar :rightBtn="true" :title="'我的收藏'"></Navbar>
  <div class="tabs-box">
    <van-tabs v-model:active="activeTabs" sticky @click-tab="changeTabs">
      <van-tab
        v-for="(item, index) in tabs"
        :title="item.title"
        :name="item.id"
      >
      </van-tab>
    </van-tabs>
  </div>
  <div class="list-wrap">
    <van-empty description="暂无数据" v-show="emptyShow" />
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getData"
      v-if="!emptyShow"
    >
      <div
        class="notice-item"
        v-for="record in list"
        :key="record"
        @click="goDetail(record)"
      >
        <div v-if="record.type != '1'">
          <!-- <list-item :record="record"></list-item> -->
          <div class="notice-item-content">
            <div
              class="notice-item-title"
              style="
                background: linear-gradient(180deg, #e6f5ff 0%, #cfecff 100%);
              "
              v-if="record.article && record.article.title"
            >
              <span
                class="level"
                v-if="record.article.level && record.article.level == '0'"
                >国</span
              >
              <span
                class="level"
                v-if="record.article.level && record.article.level == '1'"
                >省</span
              >
              <span
                class="level"
                v-if="record.article.level && record.article.level == '2'"
                >市</span
              >
              <span
                class="level"
                v-if="record.article.level && record.article.level == '3'"
                >区县</span
              >
              <span
                class="level"
                v-if="record.article.level && record.article.level > 3"
                >其他</span
              >
              {{ record.article.title }}
            </div>
            <!-- <div class="policy-file-item-tags with-row-gap">
                
                 <div class="declare-btn-box">
                    <van-button class="declare-btn" type="primary" v-if="record.article && record.article.status == '1'"
                        @click.stop="declare(record)">申报</van-button>
                    <van-button class="declare-btn" type="primary" plain hairline v-else-if="record.article && record.article.status == '0'">申报结束
                    </van-button>
                </div>
              </div> -->
            <div class="policy-content">
              <div
                v-if="record.article && record.article.description"
                v-html="record.article.description"
              ></div>
            </div>
          </div>
          <!-- <div class="notice-item-footer" v-if="record.provider == '6'"> -->
          <div class="notice-item-footer">
            <div class="flex-item" style="flex: 1">
              <div class="flex">
                <div class="policy-file-item-tags flex-item">
                  <van-tag
                    class="tag"
                    style="
                      margin-right: 4px;
                      background: #d8f4f0;
                      border-radius: 4px 4px 4px 4px;
                      color: #000000;
                    "
                  >
                    {{ record.article.dispatch_name }}
                  </van-tag>
                </div>
                <div class="flex-item" style="margin-left: 5px">
                  发布时间:{{ record.prepareDate }}
                </div>
              </div>
              <div class="flex">
                <div class="flex-item" v-if="record.article.click_num">
                  阅读量:{{ record.article.click_num }}
                </div>
                <div
                  class="flex-item"
                  style="margin-left: 5px"
                  v-if="record.article.favorite_num"
                >
                  收藏量:{{ record.article.favorite_num }}
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="policy-file-item-footer" v-if="record.type == '6'">
              <div>
                  <div  >浏览量:{{ record.article.click_num }}</div> -->
          <!-- <div >成文日期：{{ time }}</div> -->
          <!-- <div >发布日期：{{ record.prepareDate }}</div>
                </div>
                <div>
                  <div >收藏量:{{ record.article.favorite_num }}</div>     -->
          <!-- <div >发布日期：{{ record.prepareDate }}</div> -->
          <!-- </div>
                <div><span v-if="record.article && record.article.expire_date">{{ record.expire_date }}</span></div>
               <van-tag v-for="(item,index) in record.policyTopic" :key="item" :class="'tag_'+index">
                  {{ item }}
                </van-tag>
            </div> -->
        </div>
        <div class="policy-file-item-s" v-else>
          <div class="img-box">
            <img
              :src="record.provider.avatar"
              alt=""
              v-if="record.provider && record.provider.avatar"
            />
            <img src="@/assets/images/mall/img_d.jpg" alt="" v-else />
            <!--<div class="vip-img"></div>
             <div class="vip-box">
              <div class="txt">
                折扣<span>{{ record.discount }}</span
                >折
              </div>
            </div> -->
          </div>
          <div class="flex-item" style="width: 100%">
            <div class="policy-file-item-content" style="text-align:left;padding:0;">
              <div class="policy-file-item-title title_2" style="background:#fff !important;padding:0;justify-content:left;">
                {{ record.provider.name }}
              </div>
            </div>
            <div class="policy-file-item-footer" style="border-top:0;">
              <div>
                <!-- <div class="company">
                  <span class="icon-box icon-1"></span>
                  {{ record.provider.name }}
                </div> -->
                <div class="flex">
                  <div class="flex-item">
                    <span class="icon-box icon-2"></span>
                    阅读量:{{ record.provider.click_num }}
                  </div>
                </div>
                <div class="flex">
                  <div class="flex-item">
                    <span class="icon-box icon-3"></span>
                    已办理{{ record.provider.handle_num }}件
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
  <div v-if="declareShow">
    <declare-model
      :show="declareShow"
      :list="declareList"
      @declareSelected="declareSelected"
      @closeDeclare="closeDeclare"
    ></declare-model>
  </div>

  <div v-if="showCompany">
    <declare-submit
      :show="showCompany"
      :formCompany="formCompany"
      @declareSubmit="declareSubmit"
      @declareCancel="declareCancel"
    ></declare-submit>
  </div>
</template>
<script>
import {
  queryFavoritesByCompanyUserId,
  queryFavoritesByCompanyUserIdv3,
  getServiceProviderList,
  queryUserById,
} from "@/api/home";
import Navbar from "@/components/Navbar";
import ListItem from "@/components/ListItem.vue";
import DeclareModel from "@/components/DeclareModel";
import declareSubmit from "@/components/declareSubmit";
import moment from "moment";
import { clickUrl, clickUrlToPhone } from "@/utils";
import { getUserInfo } from "@/utils/storage";
import store from "@/store";

export default {
  name: "Collect",
  data() {
    return {
      activeTabs: "",
      // tabs: [
      //     { title: "全部", id: '' },
      //     { title: "政策申报", id: '4' },
      //     { title: "政策文件", id: '3' },
      //     { title: "通知公告", id: '2' },
      //     { title: "服务商", id: '1' },
      // ],
      tabs: [
        { title: "全部", id: "" },
        { title: "政策情报", id: "2" },
        // { title: "政策文件", id: '3' },
        // { title: "通知公告", id: '2' },
        { title: "服务机构", id: "1" },
      ],
      list: [],
      loading: false,
      finished: false,
      emptyShow: false,
      declareShow: false,
      showCompany: false,
      formCompany: {},
      declareList: [],
      declareInfo: {},
      company: {},
      page: {
        count: 0,
        size: 20,
        total: 0,
      },
      type: 2,
      releaseDate: 1999 - 1 - 1,
      time: 1,
    };
  },
  components: { Navbar, ListItem, DeclareModel, declareSubmit },
  computed: {},

  mounted() {
    this.getDeclareList();
    this.getCompany();
  },
  watch: {},
  methods: {
    moment,
    async getCompany() {
      let res = await queryUserById({ userId: this.$route.query.userId });
      this.company = res.data || {};
    },
    changeTabs(val) {
      this.activeTabs = val.name;
      this.page.count = 0;
      this.list = [];
      this.getData();
    },
    goDetail(item) {
      console.log(item);
      let query = { articleId: item.article_id };
      if (item.type == "6") {
        query.btnType = "1";
        query.id = item.declare_id;
        clickUrl("/article/detail", query);
      } else if (item.type == "3") {
        query.id = item.policy_id;
        clickUrl("/article/detail", query);
      } else if (item.type == "2") {
        query.id = item.notify_id;
        clickUrl("/article/detail", query);
      } else if (item.type == "1") {
        query.id = item.provider_id;
        console.log(item);
        clickUrl("/mall/detail", { id: item.provider_id, title: '服务机构信息', btnType: '1' });
      }
      // let query = { id: item.declare_id,articleId:item.id, btnType: '1' ,matchType:1,declare_id: item.declare_id}
      // clickUrl('/article/detail', query)
    },
    async getData() {
      this.page.count += 1;
      this.loading = true;
      if (this.activeTabs == 2) {
        this.type = 6;
      } else {
        this.type = this.activeTabs;
      }
      let params = {
        // type: this.type,
        page: this.page.count,
        pageSize: this.page.size,
      };
      if (this.type) {
        params.type = this.type
      }
      // if(this.activeTabs){
      // params.favoriteType = this.activeTabs
      // params.userId = this.$route.query.userId
      // }
      try {
        // if(this.type==6){
        let res = await queryFavoritesByCompanyUserIdv3(params);
        let list =
          res.result.data.map((item) => {
            let arr = [];
            if (item.article && item.article.dispatch_name)
              arr.push(item.article.dispatch_name);
            let moneyScopeMin =
              item.declare && item.declare.money_scope_min
                ? parseInt(item.declare.money_scope_min)
                : 0;
            let moneyScopeMax =
              item.declare && item.declare.money_scope_max
                ? parseInt(item.declare.money_scope_max)
                : 0;
            arr.push("资金扶持:" + moneyScopeMin + "-" + moneyScopeMax + "万");
            return {
              ...item,
              prepareDate:
                item.article && item.article.time
                  ? moment(item.article.time).format("YYYY-MM-DD")
                  : "",
              policyTopic: arr,
            };
          }) || [];
        this.list = this.list.concat(list);
        console.log(this.list);
        this.page.total = res.result.total;
        this.finished =
          this.list.length >= res.result.total && res.result.total != 0
            ? true
            : false;
        this.emptyShow = !res.result.total ? true : false;
        //   }else{
        //    let res = await queryFavoritesByCompanyUserId(params)
        //     let list = res.result.data.map((item)=>{
        //   let arr = []
        //   if(item.article && item.article.dispatch_name) arr.push(item.article.dispatch_name)
        //   let moneyScopeMin = item.declare && item.declare.money_scope_min ?parseInt(item.declare.money_scope_min):0
        //   let moneyScopeMax = item.declare && item.declare.money_scope_max ?parseInt(item.declare.money_scope_max):0
        //   if(moneyScopeMin == moneyScopeMin){
        //     arr.push('资金扶持:' + moneyScopeMin + '万')

        //   }
        //   // item.article.time = item.article.time.splice(0,10)
        //   this.time =item.create_time.slice(0,10)
        //   console.log(item.create_time.slice(0,10));
        //   // this.prepareDate = moment(item.article.time).format("YYYY-MM-DD")
        //   console.log(moment(item.create_time).format("YYYY-MM-DD"));
        //   return {
        //     ...item,
        //     policyTopic: arr,
        //   prepareDate: this.time,
        //   // releaseDate: item.create_time ? moment(item.article.create_time).format("YYYY-MM-DD") : '',
        //   }
        // }) || []
        // this.list = this.list.concat(list)
        // // this.list = this.list.concat(list)
        // console.log(this.list)
        // this.page.total = res.result.total
        // this.finished = this.list.length >= res.result.total && res.result.total != 0 ? true : false
        // this.emptyShow = !res.result.total ? true : false
        //   }
      } catch {
      } finally {
        this.loading = false;
      }
    },
    async getDeclareList() {
      let res = await getServiceProviderList({ type: "policy_declare_flag" });
      this.declareList = res.result.data ? res.result.data : [];
    },
    declare(item) {
      this.declareInfo = item;
      this.declareShow = true;
    },
    declareSelected(arg) {
      this.declareShow = false;
      let query = {
        type: "getPhone",
        declare_id: this.declareInfo.id,
        serviceProviderId: arg.id,
      };
      clickUrlToPhone("", query);
    },
    declareSubmit(arg) {
      console.log(arg);
      this.showCompany = false;
    },
    declareCancel() {
      this.formCompany = {};
      this.showCompany = false;
    },
    closeDeclare() {
      this.declareShow = false;
      this.formCompany = {};
    },
  },
};
</script>
<style lang="scss" scoped>
.policy-file-item-s {
  padding: 15px 0 15px 12px;
  margin-right: 15px;
  display: flex;
  .img-box {
    width: 73px;
    height: 73px;
    border-radius: 6px;
    position: relative;
    margin-right: 20px;

    img {
      width: 73px;
      height: 73px;
      background-size: 100% 100%;
      border-radius: 6px;
    }

    .vip-img {
      position: absolute;
      z-index: 10;
      bottom: 0;
      left: -13px;
      width: 90px;
      height: 21px;
      background: url("../../assets/images/mall/icon_vip@2x.png") no-repeat
        center center;
      background-size: cover;
      z-index: 1;
    }

    .vip-box {
      position: absolute;
      z-index: 5;
      bottom: 0;
      left: 0;
      width: 60px;
      height: 14px;
      color: #fff;
      text-align: center;
      line-height: 14px;
      padding-left: 7px;
      font-size: 12px;

      .txt {
        transform: scale(0.8);
        white-space: nowrap;
      }

      span {
        color: #ff0000;
        font-size: 14px;
        font-weight: 600;
        margin: 0 3px;
      }
    }
  }

  .policy-file-item {
    & {
      margin: 12px 3px;
      background: #ffffff;
      box-shadow: 0px 4px 8px 1px rgba(128, 107, 78, 0.15);
      border-radius: 8px;
    }

    &-title {
      padding: 7px;
      font-weight: 550;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      background: linear-gradient(180deg, #e6f5ff 0%, #cfecff 100%);
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
  }
  .policy-file-item-content {
    position: relative;
  }

  .policy-file-item-footer {
    padding: 7px 0 0;

    > div {
      width: 100%;
    }
  }

  .policy-file-item-title {
    padding: 7px;
    font-weight: 550;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    background: linear-gradient(180deg, #e6f5ff 0%, #cfecff 100%) !important;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex !important;
    justify-content: space-around;
  }

  .icon-box {
    display: inline-block;
    width: 15px;
    height: 15px;
    vertical-align: middle;

    &.icon-1 {
      background: url("../../assets/images/mall/icon_3@2x.png") no-repeat center
        center;
      background-size: contain;
    }

    &.icon-2 {
      background: url("../../assets/images/mall/icon_2@2x.png") no-repeat center
        center;
      background-size: contain;
    }

    &.icon-3 {
      background: url("../../assets/images/mall/icon_1@2x.png") no-repeat center
        center;
      background-size: contain;
    }
  }
}
.tabs-box {
  position: fixed;
  top: 46px;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 10;
}
.list-wrap {
  margin-top: 60px;
  padding: 0 13px 13px;
}
.notice-item {
  & {
    margin: 12px 3px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 1px rgba(128, 107, 78, 0.15);
    border-radius: 8px;
  }

  &-title {
    padding: 7px;
    font-weight: 550;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    background: linear-gradient(180deg, #e6f5ff 0%, #cfecff 100%);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .policy-content {
    padding: 5px 7px 0;
  }

  &-tags {
    display: flex;
    flex-wrap: wrap;
  }

  &-tags > * {
    margin-bottom: 8px;
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    color: #666;
    font-size: 12px;
    padding: 10px 7px 10px;
  }

  &-footer > flex {
    justify-content: space-between;
  }
}
//    .notice-item-title{
//       display: flex !important;
//       justify-content: space-around;
//   }
// .notice-item-content{
//     position: relative;
//     // padding-bottom: 10px;
//     font-family: PingFang SC-Regular, PingFang SC;
// font-weight: 400;
// color: #2B2B2B;
// }
.policy-content {
  /* margin-bottom: 10px; */
  padding: 10px 0px;
}
.declare-btn {
  background: #1989fa;
  border-radius: 14px 14px 14px 14px;
  opacity: 1;
  color: #fff;
  border: none;
}
// .policy-file-item-tags {
// float: right;
// margin-top: 8px;
// }
.van-tag--default {
  background-color: #fff;
  color: #000;
}
.level {
  height: 16px;
  font-size: 12px;
  font-weight: 400;
  padding: 3px;
  background: #1989fa;
  color: #fff;
  border-radius: 4px;
}

.policy-file-item-tags {
  display: flex;
  flex-wrap: wrap;
  // max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tag {
  padding: 0 3px;
  border-radius: 4px;
  font-weight: 400;
  margin-right: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;

  &.tag_0 {
    background: rgba(216, 244, 240, 0.5);
    border: 1px solid rgba(51, 151, 139, 0.8);
    color: #33978b;
  }

  &.tag_1 {
    background: rgba(139, 184, 213, 0.15);
    border: 1px solid #8bb8d5;
    color: #8bb8d5;
  }
}
</style>